import React, { useEffect, useState } from "react";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";
import { IoReloadOutline, IoSaveOutline } from "react-icons/io5";
import { PiBroomBold } from "react-icons/pi";
import { FiHash } from "react-icons/fi";
import { maxios } from "../../store/maxios";
import { FaLanguage } from "react-icons/fa";

function QuestionPanel({
  saving,
  setSaving,
  question,
  saveAndNextQuestion,
  clear,
  prev,
  next,
  index,
  submitPaper,
}) {
  const [selected, setSelected] = useState(
    Number(localStorage.getItem(question.code)) || ""
  );

  const clearAttempt = () => {

    if(navigator.onLine){
    setSelected("");
    clear();
    }
    else{
      alert("NET NAHI HAI")
    }

  };
  const handleChange = (event) => {
    const value = Number(event.target.value); // Convert to number
    setSelected(value);

    if (value !== "") {
      localStorage.setItem("lastSelection", value || "");
      localStorage.setItem(question.code || "aa", value || "");
    } else {
      localStorage.removeItem("lastSelection");
    }
  };
  useEffect(() => {
    setSelected(Number(localStorage.getItem(question.code)) || "");
    if (
      localStorage.getItem(question.code) == null ||
      localStorage.getItem(question.code) == ""
    ) {
    } else {
      localStorage.setItem(
        "lastSelection",
        localStorage.getItem(question.code)
      );
    }
  }, [question.code]);

  const [viewHindi, setViewHindi] = useState(false);

  return (
    <div className="question-panel">
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "1rem",
        }}
      >
        <button
          type="button"
          onClick={() => setViewHindi(!viewHindi)}
          style={{
            backgroundColor: "#4A5568", // a soft gray-blue
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 16px",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            gap: "8px",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s ease",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#2D3748")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#4A5568")
          }
        >
          <FaLanguage size={24} />
          {viewHindi ? "English" : "Hindi"}
        </button>
      </div> */}

      <div className="q-o-box">
        <h4>
          Question <FiHash /> {index + 1}
        </h4>
        <p>{viewHindi == true ? question.text_hindi : question.text}</p>
        <p style={{ textAlign: "center" }}>
          {question.question_image.includes("https") && (
            <img
              src={question.question_image}
              style={{
                height: "100px",
                width: "auto",
                margin: "auto",
                transition: "transform 0.3s ease-in-out",
                maxWidth:'600px'
              }}
              className="zoom-image"
            />
          )}{" "}
        </p>
        <ul>
          <li>
            <input
              className="custom-radio"
              type="radio"
              name={`q${question.code}`}
              value={1}
              checked={selected === 1 ? true : false}
              onChange={handleChange}
            />{" "}
            
            
            {question.op1.includes("https://") ?<><img
                src={question.op1}
                style={{
                  height: "40px",
                  width: "auto",
                  transition: "transform 0.3s ease-in-out",
                }}
                className="zoom-image2"
              /></> :question.op1}
          </li>
          <li>
            <input
              className="custom-radio"
              type="radio"
              name={`q${question.code}`}
              value={2}
              checked={selected === 2 ? true : false}
              onChange={handleChange}
            />{" "}
           {question.op2.includes("https://") ?<><img
                src={question.op2}
                style={{
                  height: "40px",
                  width: "auto",
                  transition: "transform 0.3s ease-in-out",
                }}
                className="zoom-image2"
              /></> :question.op2}
          </li>
          <li>
            <input
              className="custom-radio"
              type="radio"
              name={`q${question.code}`}
              value={3}
              checked={selected === 3 ? true : false}
              onChange={handleChange}
            />{" "}
            {question.op3.includes("https://") ?<><img
                src={question.op3}
                style={{
                  height: "40px",
                  width: "auto",
                  transition: "transform 0.3s ease-in-out",
                }}
                className="zoom-image2"
              /></> :question.op3}
          </li>
          <li>
            <input
              className="custom-radio"
              type="radio"
              name={`q${question.code}`}
              value={4}
              checked={selected === 4 ? true : false}
              onChange={handleChange}
            />{" "}
             {question.op4.includes("https://") ?<><img
                src={question.op4}
                style={{
                  height: "40px",
                  width: "auto",
                  transition: "transform 0.3s ease-in-out",
                }}
                className="zoom-image2"
              /></> :question.op4}
          </li>
        </ul>
      </div>

      <div
        className="question-buttons"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "end",
          width: "100%",
          marginTop: "20px",
        }}
      >
        {saving==true ? <>
        <button className="save-btn" onClick={()=>{}}>
          <IoReloadOutline /> Saving...
        </button>
        </>:<button className="save-btn" onClick={saveAndNextQuestion}>
          <IoSaveOutline /> Save & Next
        </button>}
        
        <button className="clear-btn" onClick={clearAttempt}>
          <PiBroomBold /> Clear
        </button>
      </div>

      <ul
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "20px",
        }}
      >
        <li>
          <button className="toggle-button" onClick={prev}>
            <GrLinkPrevious /> Prev
          </button>
          <button className="toggle-button" onClick={next}>
            Next <GrLinkNext />
          </button>
        </li>
        <li>
          <button className="toggle-button" onClick={submitPaper}>
            Submit Exam
          </button>
        </li>
      </ul>
    </div>
  );
}

export default QuestionPanel;
